import React from 'react';

const IconPackImport = () => {
	//nao mexer, esquecer que isso existe
	return (
		<div id="styles_iconpack" style={{ display: 'none' }}>
			<svg className="dn" height="0" version="1.1" width="0" xmlns="http://www.w3.org/2000/svg">
				<defs>
					<g id="bnd-logo">
						<path
							d="M14.8018 2H2.8541C1.92768 2 1.33445 2.93596 1.76795 3.71405L2.96368 5.86466H0.796482C0.659276 5.8647 0.524407 5.89841 0.404937 5.96253C0.285467 6.02665 0.185446 6.119 0.114562 6.23064C0.0436777 6.34228 0.0043325 6.46943 0.000337815 6.59976C-0.00365688 6.73009 0.0278339 6.8592 0.0917605 6.97457L3.93578 13.8888C4.00355 14.0104 4.10491 14.1121 4.22896 14.1831C4.35301 14.254 4.49507 14.2915 4.63987 14.2915C4.78466 14.2915 4.92672 14.254 5.05077 14.1831C5.17483 14.1121 5.27618 14.0104 5.34395 13.8888L6.38793 12.0211L7.69771 14.3775C8.15868 15.2063 9.40744 15.2078 9.87001 14.38L15.8585 3.67064C16.2818 2.91319 15.7043 2 14.8018 2ZM9.43491 6.57566L6.85274 11.1944C6.80761 11.2753 6.74016 11.3429 6.65762 11.3901C6.57508 11.4373 6.48058 11.4622 6.38426 11.4622C6.28794 11.4622 6.19344 11.4373 6.1109 11.3901C6.02836 11.3429 5.96091 11.2753 5.91578 11.1944L3.35853 6.59509C3.31587 6.51831 3.29482 6.43236 3.2974 6.34558C3.29998 6.25879 3.3261 6.17411 3.37325 6.09974C3.4204 6.02538 3.48696 5.96385 3.56649 5.92112C3.64601 5.87839 3.73581 5.85591 3.82717 5.85585H8.97937C9.06831 5.85591 9.15572 5.87782 9.23312 5.91945C9.31052 5.96108 9.37529 6.02102 9.42113 6.09345C9.46697 6.16588 9.49232 6.24834 9.49474 6.33283C9.49716 6.41732 9.47655 6.50097 9.43491 6.57566Z"
							fill="currentColor"
						></path>
						<path
							d="M14.8018 2H2.8541C1.92768 2 1.33445 2.93596 1.76795 3.71405L2.96368 5.86466H0.796482C0.659276 5.8647 0.524407 5.89841 0.404937 5.96253C0.285467 6.02665 0.185446 6.119 0.114562 6.23064C0.0436777 6.34228 0.0043325 6.46943 0.000337815 6.59976C-0.00365688 6.73009 0.0278339 6.8592 0.0917605 6.97457L3.93578 13.8888C4.00355 14.0104 4.10491 14.1121 4.22896 14.1831C4.35301 14.254 4.49507 14.2915 4.63987 14.2915C4.78466 14.2915 4.92672 14.254 5.05077 14.1831C5.17483 14.1121 5.27618 14.0104 5.34395 13.8888L6.38793 12.0211L7.69771 14.3775C8.15868 15.2063 9.40744 15.2078 9.87001 14.38L15.8585 3.67064C16.2818 2.91319 15.7043 2 14.8018 2ZM9.43491 6.57566L6.85274 11.1944C6.80761 11.2753 6.74016 11.3429 6.65762 11.3901C6.57508 11.4373 6.48058 11.4622 6.38426 11.4622C6.28794 11.4622 6.19344 11.4373 6.1109 11.3901C6.02836 11.3429 5.96091 11.2753 5.91578 11.1944L3.35853 6.59509C3.31587 6.51831 3.29482 6.43236 3.2974 6.34558C3.29998 6.25879 3.3261 6.17411 3.37325 6.09974C3.4204 6.02538 3.48696 5.96385 3.56649 5.92112C3.64601 5.87839 3.73581 5.85591 3.82717 5.85585H8.97937C9.06831 5.85591 9.15572 5.87782 9.23312 5.91945C9.31052 5.96108 9.37529 6.02102 9.42113 6.09345C9.46697 6.16588 9.49232 6.24834 9.49474 6.33283C9.49716 6.41732 9.47655 6.50097 9.43491 6.57566Z"
							fill="currentColor"
						></path>
					</g>
					<g id="hpa-arrow-from-bottom">
						<path
							d="M7.00001 3.4V12H9.00001V3.4L13 7.4L14.4 6L8.70001 0.3C8.30001 -0.1 7.70001 -0.1 7.30001 0.3L1.60001 6L3.00001 7.4L7.00001 3.4Z"
							fill="currentColor"
						></path>
						<path d="M15 14H1V16H15V14Z" fill="currentColor"></path>
					</g>
					<g id="hpa-arrow-to-bottom">
						<path
							d="M8.00001 12C8.30001 12 8.50001 11.9 8.70001 11.7L14.4 6L13 4.6L9.00001 8.6V0H7.00001V8.6L3.00001 4.6L1.60001 6L7.30001 11.7C7.50001 11.9 7.70001 12 8.00001 12Z"
							fill="currentColor"
						></path>
						<path d="M15 14H1V16H15V14Z" fill="currentColor"></path>
					</g>
					<g id="hpa-arrow-back">
						<path
							d="M5.5 15.5002C5.75781 15.5002 5.92969 15.4169 6.10156 15.2502L11 10.5002L9.79687 9.33356L6.35938 12.6669L6.35938 0H4.64063L4.64062 12.6669L1.20312 9.33356L0 10.5002L4.89844 15.2502C5.07031 15.4169 5.24219 15.5002 5.5 15.5002Z"
							transform="translate(16.0002) rotate(90)"
							fill="currentColor"
						></path>
					</g>
					<g id="hpa-calendar">
						<path
							d="M5.66667 7.2H4.11111V8.8H5.66667V7.2ZM8.77778 7.2H7.22222V8.8H8.77778V7.2ZM11.8889 7.2H10.3333V8.8H11.8889V7.2ZM13.4444 1.6H12.6667V0H11.1111V1.6H4.88889V0H3.33333V1.6H2.55556C1.69222 1.6 1.00778 2.32 1.00778 3.2L1 14.4C1 15.28 1.69222 16 2.55556 16H13.4444C14.3 16 15 15.28 15 14.4V3.2C15 2.32 14.3 1.6 13.4444 1.6ZM13.4444 14.4H2.55556V5.6H13.4444V14.4Z"
							fill="currentColor"
						></path>
					</g>
					<g id="hpa-cart">
						<path
							d="M15.0503 3.0002H4.92647C4.81221 3.00072 4.7012 2.96234 4.6118 2.89142C4.52239 2.8205 4.45996 2.72129 4.43483 2.6102L4.01342 0.800203C3.96651 0.570928 3.84041 0.365306 3.65708 0.219131C3.47375 0.0729566 3.24479 -0.00451449 3.01006 0.000203439H0.501677C0.368624 0.000203439 0.241021 0.0528819 0.146938 0.14665C0.0528551 0.240418 0 0.367595 0 0.500203L0 1.5002C0 1.63281 0.0528551 1.75999 0.146938 1.85376C0.241021 1.94753 0.368624 2.0002 0.501677 2.0002H1.80604C1.92077 1.9978 2.03274 2.03548 2.12253 2.10671C2.21232 2.17794 2.27429 2.27823 2.29768 2.3902L4.01342 10.2002C4.06032 10.4295 4.18642 10.6351 4.36975 10.7813C4.55308 10.9274 4.78204 11.0049 5.01677 11.0002H13.0436C13.2478 10.9891 13.4436 10.9161 13.605 10.791C13.7664 10.6659 13.8856 10.4947 13.9466 10.3002L15.9533 4.3002C15.9995 4.15468 16.0116 4.00057 15.9888 3.84965C15.9659 3.69874 15.9088 3.55504 15.8216 3.42956C15.7344 3.30408 15.6196 3.20015 15.4859 3.12573C15.3522 3.0513 15.2032 3.00837 15.0503 3.0002Z"
							fill="currentColor"
						></path>
						<path
							d="M5.02682 16.0002C6.13509 16.0002 7.03353 15.1048 7.03353 14.0002C7.03353 12.8956 6.13509 12.0002 5.02682 12.0002C3.91855 12.0002 3.02011 12.8956 3.02011 14.0002C3.02011 15.1048 3.91855 16.0002 5.02682 16.0002Z"
							fill="currentColor"
						></path>
						<path
							d="M13.0737 16.0002C14.182 16.0002 15.0804 15.1048 15.0804 14.0002C15.0804 12.8956 14.182 12.0002 13.0737 12.0002C11.9655 12.0002 11.067 12.8956 11.067 14.0002C11.067 15.1048 11.9655 16.0002 13.0737 16.0002Z"
							fill="currentColor"
						></path>
					</g>
					<g id="hpa-delete">
						<path d="M7 7H5V13H7V7Z" fill="currentColor"></path>
						<path d="M11 7H9V13H11V7Z" fill="currentColor"></path>
						<path
							d="M12 1C12 0.4 11.6 0 11 0H5C4.4 0 4 0.4 4 1V3H0V5H1V15C1 15.6 1.4 16 2 16H14C14.6 16 15 15.6 15 15V5H16V3H12V1ZM6 2H10V3H6V2ZM13 5V14H3V5H13Z"
							fill="currentColor"
						></path>
					</g>
					<g id="mpa-play">
						<path
							d="M3.5241 0.937906C2.85783 0.527894 2 1.00724 2 1.78956V14.2104C2 14.9928 2.85783 15.4721 3.5241 15.0621L13.6161 8.85166C14.2506 8.46117 14.2506 7.53883 13.6161 7.14834L3.5241 0.937906Z"
							fill="currentColor"
						></path>
					</g>
					<g id="mpa-pause">
						<rect width="6" height="16" fill="currentColor"></rect>
						<rect x="10" width="6" height="16" fill="currentColor"></rect>
					</g>
					<g id="sti-volume-on">
						<path
							d="M0 5.2634V10.7366H3.55556L8 15.2976V0.702394L3.55556 5.2634H0ZM12 8C12 6.3854 11.0933 4.99886 9.77778 4.32383V11.667C11.0933 11.0011 12 9.6146 12 8ZM9.77778 0V1.87913C12.3467 2.66363 14.2222 5.10832 14.2222 8C14.2222 10.8917 12.3467 13.3364 9.77778 14.1209V16C13.3422 15.1699 16 11.9042 16 8C16 4.09578 13.3422 0.830103 9.77778 0V0Z"
							fill="currentColor"
						></path>
					</g>
					<g id="sti-volume-off">
						<path
							d="M12 8C12 6.42667 11.0933 5.07556 9.77778 4.41778V6.38222L11.9556 8.56C11.9822 8.38222 12 8.19556 12 8V8ZM14.2222 8C14.2222 8.83556 14.0444 9.61778 13.7422 10.3467L15.0844 11.6889C15.6711 10.5867 16 9.33333 16 8C16 4.19556 13.3422 1.01333 9.77778 0.204444V2.03556C12.3467 2.8 14.2222 5.18222 14.2222 8ZM1.12889 0L0 1.12889L4.20444 5.33333H0V10.6667H3.55556L8 15.1111V9.12889L11.7778 12.9067C11.1822 13.3689 10.5156 13.7333 9.77778 13.9556V15.7867C11.0044 15.5111 12.1156 14.9422 13.0578 14.1778L14.8711 16L16 14.8711L8 6.87111L1.12889 0ZM8 0.888889L6.14222 2.74667L8 4.60444V0.888889Z"
							fill="currentColor"
						></path>
					</g>
					<g id="hpa-profile">
						<path
							d="M7.99 8C10.1964 8 11.985 6.20914 11.985 4C11.985 1.79086 10.1964 0 7.99 0C5.78362 0 3.995 1.79086 3.995 4C3.995 6.20914 5.78362 8 7.99 8Z"
							fill="currentColor"
						></path>
						<path
							d="M14.8215 11.38C15.1694 11.5401 15.4641 11.7969 15.6704 12.12C15.8791 12.442 15.9933 12.8162 16 13.2V15.49V16H15.4906H0.509363H0V15.49V13.2C0.000731876 12.8181 0.107964 12.4441 0.309613 12.12C0.515896 11.7969 0.810577 11.5401 1.15855 11.38C3.31243 10.4409 5.64096 9.97049 7.99001 9.99999C10.3391 9.97049 12.6676 10.4409 14.8215 11.38Z"
							fill="currentColor"
						></path>
					</g>
					<g id="hpa-save">
						<path
							d="M11.7 0.3C11.5 0.1 11.3 0 11 0H10V3C10 3.6 9.6 4 9 4H4C3.4 4 3 3.6 3 3V0H1C0.4 0 0 0.4 0 1V15C0 15.6 0.4 16 1 16H15C15.6 16 16 15.6 16 15V5C16 4.7 15.9 4.5 15.7 4.3L11.7 0.3ZM13 14H3V11C3 10.4 3.4 10 4 10H12C12.6 10 13 10.4 13 11V14Z"
							fill="currentColor"
						></path>
						<path d="M9 0H7V3H9V0Z" fill="currentColor"></path>
					</g>
					<g id="hpa-search">
						<path
							d="M15.707 13.293L13 10.586C13.63 9.536 14 8.311 14 7C14 3.14 10.859 0 7 0C3.141 0 0 3.14 0 7C0 10.86 3.141 14 7 14C8.312 14 9.536 13.631 10.586 13L13.293 15.707C13.488 15.902 13.744 16 14 16C14.256 16 14.512 15.902 14.707 15.707L15.707 14.707C16.098 14.316 16.098 13.684 15.707 13.293ZM7 12C4.239 12 2 9.761 2 7C2 4.239 4.239 2 7 2C9.761 2 12 4.239 12 7C12 9.761 9.761 12 7 12Z"
							fill="currentColor"
						></path>
					</g>
					<g id="hpa-hamburguer-menu">
						<path fill="currentColor" d="M15,7H1C0.4,7,0,7.4,0,8s0.4,1,1,1h14c0.6,0,1-0.4,1-1S15.6,7,15,7z"></path>
						<path fill="currentColor" d="M15,1H1C0.4,1,0,1.4,0,2s0.4,1,1,1h14c0.6,0,1-0.4,1-1S15.6,1,15,1z"></path>
						<path fill="currentColor" d="M15,13H1c-0.6,0-1,0.4-1,1s0.4,1,1,1h14c0.6,0,1-0.4,1-1S15.6,13,15,13z"></path>
					</g>
					<g id="hpa-location-marker">
						<path
							d="M19.9655 10.4828C19.9655 16.3448 10.4828 26 10.4828 26C10.4828 26 1 16.431 1 10.4828C1 4.44828 5.91379 1 10.4828 1C15.0517 1 19.9655 4.53448 19.9655 10.4828Z"
							stroke="currentColor"
							strokeWidth="2"
							strokeMiterlimit="10"
							strokeLinecap="round"
							strokeLinejoin="round"
						></path>
						<path
							d="M10.4827 13.069C11.911 13.069 13.0689 11.9111 13.0689 10.4828C13.0689 9.05443 11.911 7.89655 10.4827 7.89655C9.05437 7.89655 7.89648 9.05443 7.89648 10.4828C7.89648 11.9111 9.05437 13.069 10.4827 13.069Z"
							stroke="currentColor"
							strokeWidth="2"
							strokeMiterlimit="10"
							strokeLinecap="round"
							strokeLinejoin="round"
						></path>
					</g>
					<g id="hpa-telemarketing">
						<path
							d="M14 10V7C14 3.68629 11.3137 1 8 1V1C4.68629 1 2 3.68629 2 7V10"
							stroke="currentColor"
							strokeWidth="1.5"
						></path>
						<path d="M14 10V10C14 12.2091 12.2091 14 10 14H8" stroke="currentColor" strokeWidth="1.5"></path>
						<rect y="7" width="3" height="5" rx="1" fill="currentColor"></rect>
						<rect x="11" y="12" width="4" height="5" rx="2" transform="rotate(90 11 12)" fill="currentColor"></rect>
						<rect x="13" y="7" width="3" height="5" rx="1" fill="currentColor"></rect>
					</g>
					<g id="mpa-globe">
						<path
							d="M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M13.9,7H12c-0.1-1.5-0.4-2.9-0.8-4.1 C12.6,3.8,13.6,5.3,13.9,7z M8,14c-0.6,0-1.8-1.9-2-5H10C9.8,12.1,8.6,14,8,14z M6,7c0.2-3.1,1.3-5,2-5s1.8,1.9,2,5H6z M4.9,2.9 C4.4,4.1,4.1,5.5,4,7H2.1C2.4,5.3,3.4,3.8,4.9,2.9z M2.1,9H4c0.1,1.5,0.4,2.9,0.8,4.1C3.4,12.2,2.4,10.7,2.1,9z M11.1,13.1 c0.5-1.2,0.7-2.6,0.8-4.1h1.9C13.6,10.7,12.6,12.2,11.1,13.1z"
							fill="currentColor"
						></path>
					</g>
					<g id="mpa-filter-settings">
						<path d="M4 5V1" stroke="#4F4F4F" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"></path>
						<path
							d="M4 16V14"
							stroke="#4F4F4F"
							strokeMiterlimit="10"
							strokeLinecap="round"
							strokeLinejoin="round"
						></path>
						<path
							d="M13 12V16"
							stroke="#4F4F4F"
							strokeMiterlimit="10"
							strokeLinecap="round"
							strokeLinejoin="round"
						></path>
						<path
							d="M13 1V3"
							stroke="#4F4F4F"
							strokeMiterlimit="10"
							strokeLinecap="round"
							strokeLinejoin="round"
						></path>
						<path
							d="M4 14C5.65685 14 7 12.6569 7 11C7 9.34315 5.65685 8 4 8C2.34315 8 1 9.34315 1 11C1 12.6569 2.34315 14 4 14Z"
							stroke="#4F4F4F"
							strokeMiterlimit="10"
							strokeLinecap="round"
							strokeLinejoin="round"
						></path>
						<path
							d="M13 9C14.6569 9 16 7.65685 16 6C16 4.34315 14.6569 3 13 3C11.3431 3 10 4.34315 10 6C10 7.65685 11.3431 9 13 9Z"
							stroke="#4F4F4F"
							strokeMiterlimit="10"
							strokeLinecap="round"
							strokeLinejoin="round"
						></path>
					</g>
					<g id="mpa-single-item">
						<path
							d="M10.2857 0H1.71429C0.685714 0 0 0.685714 0 1.71429V10.2857C0 11.3143 0.685714 12 1.71429 12H10.2857C11.3143 12 12 11.3143 12 10.2857V1.71429C12 0.685714 11.3143 0 10.2857 0Z"
							fill="currentColor"
						></path>
						<rect y="14" width="12" height="2" rx="1" fill="currentColor"></rect>
					</g>
					<g id="mpa-gallery">
						<path
							d="M6 0H1C0.4 0 0 0.4 0 1V6C0 6.6 0.4 7 1 7H6C6.6 7 7 6.6 7 6V1C7 0.4 6.6 0 6 0Z"
							fill="currentColor"
						></path>
						<path
							d="M15 0H10C9.4 0 9 0.4 9 1V6C9 6.6 9.4 7 10 7H15C15.6 7 16 6.6 16 6V1C16 0.4 15.6 0 15 0Z"
							fill="currentColor"
						></path>
						<path
							d="M6 9H1C0.4 9 0 9.4 0 10V15C0 15.6 0.4 16 1 16H6C6.6 16 7 15.6 7 15V10C7 9.4 6.6 9 6 9Z"
							fill="currentColor"
						></path>
						<path
							d="M15 9H10C9.4 9 9 9.4 9 10V15C9 15.6 9.4 16 10 16H15C15.6 16 16 15.6 16 15V10C16 9.4 15.6 9 15 9Z"
							fill="currentColor"
						></path>
					</g>
					<g id="mpa-list-items">
						<path
							d="M6 0H1C0.4 0 0 0.4 0 1V6C0 6.6 0.4 7 1 7H6C6.6 7 7 6.6 7 6V1C7 0.4 6.6 0 6 0Z"
							fill="currentColor"
						></path>
						<rect x="9" width="7" height="3" rx="1" fill="currentColor"></rect>
						<rect x="9" y="4" width="4" height="3" rx="1" fill="currentColor"></rect>
						<rect x="9" y="9" width="7" height="3" rx="1" fill="currentColor"></rect>
						<rect x="9" y="13" width="4" height="3" rx="1" fill="currentColor"></rect>
						<path
							d="M6 9H1C0.4 9 0 9.4 0 10V15C0 15.6 0.4 16 1 16H6C6.6 16 7 15.6 7 15V10C7 9.4 6.6 9 6 9Z"
							fill="currentColor"
						></path>
					</g>
					<g id="mpa-heart">
						<path
							d="M14.682 2.31811C14.2647 1.89959 13.7687 1.56769 13.2226 1.3415C12.6765 1.11531 12.0911 0.99929 11.5 1.00011C10.8245 0.995238 10.157 1.14681 9.54975 1.44295C8.94255 1.73909 8.41213 2.17178 8.00004 2.70711C7.58764 2.17212 7.05716 1.73969 6.45002 1.44358C5.84289 1.14747 5.17552 0.995697 4.50004 1.00011C3.61002 1.00011 2.73998 1.26402 1.99995 1.75849C1.25993 2.25295 0.683144 2.95576 0.342546 3.77803C0.00194874 4.60031 -0.0871663 5.50511 0.0864704 6.37803C0.260107 7.25095 0.688697 8.05278 1.31804 8.68211L8.00004 15.0001L14.682 8.68211C15.0999 8.26425 15.4314 7.76817 15.6575 7.2222C15.8837 6.67623 16.0001 6.09107 16.0001 5.50011C16.0001 4.90916 15.8837 4.32399 15.6575 3.77803C15.4314 3.23206 15.0999 2.73598 14.682 2.31811V2.31811ZM13.282 7.25111L8.00004 12.2471L2.71504 7.24711C2.37145 6.8954 2.1392 6.45018 2.04734 5.96715C1.95549 5.48412 2.00811 4.98473 2.19862 4.53145C2.38913 4.07817 2.70908 3.69113 3.11843 3.41876C3.52778 3.14638 4.00835 3.00076 4.50004 3.00011C5.93704 3.00011 6.81204 3.68111 8.00004 5.62511C9.18704 3.68111 10.062 3.00011 11.5 3.00011C11.9925 2.99999 12.4741 3.14534 12.8843 3.41791C13.2945 3.69048 13.615 4.07814 13.8057 4.53223C13.9964 4.98632 14.0487 5.48661 13.956 5.97031C13.8634 6.45402 13.63 6.89959 13.285 7.25111H13.282Z"
							fill="currentColor"
						></path>
					</g>
					<g id="mpa-clone--outline">
						<path
							d="M5.20004 5.2L5.20004 3C5.20004 1.89543 6.09547 0.999997 7.20004 0.999997H13C14.1046 0.999997 15 1.89543 15 3V8.80001C15 9.90457 14.1046 10.8 13 10.8H10.8"
							stroke="currentColor"
							strokeWidth="2"
							strokeMiterlimit="10"
							strokeLinecap="square"
						></path>
						<path
							d="M1 7.19999L1 13C1 14.1046 1.89543 15 3 15H8.79997C9.90454 15 10.8 14.1046 10.8 13V7.19999C10.8 6.09542 9.90454 5.19999 8.79997 5.19999H3C1.89543 5.19999 1 6.09542 1 7.19999Z"
							stroke="currentColor"
							strokeWidth="2"
							strokeMiterlimit="10"
							strokeLinecap="square"
						></path>
					</g>
					<g id="mpa-clone--filled">
						<path
							d="M6.07501 4.925L6.07501 2.175C6.07501 1.62271 6.52273 1.175 7.07501 1.175H13.825C14.3773 1.175 14.825 1.62271 14.825 2.175V8.925C14.825 9.47729 14.3773 9.925 13.825 9.925H11.075"
							fill="currentColor"
						></path>
						<path
							d="M6.07501 4.925L6.07501 2.175C6.07501 1.62271 6.52273 1.175 7.07501 1.175H13.825C14.3773 1.175 14.825 1.62271 14.825 2.175V8.925C14.825 9.47729 14.3773 9.925 13.825 9.925H11.075"
							stroke="currentColor"
							strokeWidth="2"
							strokeMiterlimit="10"
							strokeLinecap="square"
						></path>
						<path
							d="M1 6.49999L1 13C1 14.1046 1.89543 15 3 15H9.49997C10.6045 15 11.5 14.1046 11.5 13V6.49999C11.5 5.39542 10.6045 4.49999 9.49997 4.49999H3C1.89543 4.49999 1 5.39542 1 6.49999Z"
							fill="currentColor"
							stroke="white"
							strokeWidth="2"
							strokeMiterlimit="10"
							strokeLinecap="square"
						></path>
					</g>
					<g id="mpa-edit--outline">
						<path
							d="M11.7 0.3C11.3 -0.1 10.7 -0.1 10.3 0.3L0.3 10.3C0.1 10.5 0 10.7 0 11V15C0 15.6 0.4 16 1 16H5C5.3 16 5.5 15.9 5.7 15.7L15.7 5.7C16.1 5.3 16.1 4.7 15.7 4.3L11.7 0.3ZM4.6 14H2V11.4L8 5.4L10.6 8L4.6 14ZM12 6.6L9.4 4L11 2.4L13.6 5L12 6.6Z"
							fill="currentColor"
						></path>
					</g>
					<g id="mpa-bookmark--filled">
						<path
							d="M3.33333 0C2.05 0 1 0.9 1 2V16L8 13L15 16V2C15 0.9 13.95 0 12.6667 0H3.33333Z"
							fill="currentColor"
						></path>
					</g>
					<g id="mpa-bookmark--outline">
						<path
							d="M13 2V13.3L8 11.9L3 13.3V2H13ZM13 0H3C1.9 0 1 0.9 1 2V16L8 14L15 16V2C15 0.9 14.1 0 13 0Z"
							fill="currentColor"
						></path>
					</g>
					<g id="mpa-edit--filled">
						<path
							d="M8.1 3.5L0.3 11.3C0.1 11.5 0 11.7 0 12V15C0 15.6 0.4 16 1 16H4C4.3 16 4.5 15.9 4.7 15.7L12.5 7.9L8.1 3.5Z"
							fill="currentColor"
						></path>
						<path
							d="M15.7 3.3L12.7 0.3C12.3 -0.1 11.7 -0.1 11.3 0.3L9.5 2.1L13.9 6.5L15.7 4.7C16.1 4.3 16.1 3.7 15.7 3.3Z"
							fill="currentColor"
						></path>
					</g>
					<g id="mpa-external-link--line">
						<path
							d="M14.3505 0H2.80412V3.29897H10.3918L0 13.6907L2.30928 16L12.701 5.60825V13.1959H16V1.64948C16 0.659794 15.3402 0 14.3505 0Z"
							fill="currentColor"
						></path>
					</g>
					<g id="mpa-external-link--outline">
						<path d="M15 0H8V2H12.6L6.3 8.3L7.7 9.7L14 3.4V8H16V1C16 0.4 15.6 0 15 0Z" fill="currentColor"></path>
						<path
							d="M14 16H1C0.4 16 0 15.6 0 15V2C0 1.4 0.4 1 1 1H5V3H2V14H13V11H15V15C15 15.6 14.6 16 14 16Z"
							fill="currentColor"
						></path>
					</g>
					<g id="mpa-eyesight--outline--off">
						<path
							d="M14.5744 5.66925L13.1504 7.09325C13.4284 7.44025 13.6564 7.75725 13.8194 8.00025C13.0594 9.13025 10.9694 11.8203 8.25838 11.9852L6.44337 13.8003C6.93937 13.9243 7.45737 14.0002 8.00037 14.0002C12.7074 14.0002 15.7444 8.71625 15.8714 8.49225C16.0424 8.18825 16.0434 7.81625 15.8724 7.51225C15.8254 7.42725 15.3724 6.63125 14.5744 5.66925Z"
							fill="currentColor"
						></path>
						<path
							d="M0.293375 15.7072C0.488375 15.9022 0.744375 16.0002 1.00038 16.0002C1.25638 16.0002 1.51238 15.9022 1.70738 15.7072L15.7074 1.70725C16.0984 1.31625 16.0984 0.68425 15.7074 0.29325C15.3164 -0.09775 14.6844 -0.09775 14.2934 0.29325L11.5484 3.03825C10.5154 2.43125 9.33138 2.00025 8.00037 2.00025C3.24537 2.00025 0.251375 7.28925 0.126375 7.51425C-0.0426249 7.81725 -0.0416249 8.18625 0.128375 8.48925C0.198375 8.61425 1.17238 10.2913 2.82138 11.7653L0.292375 14.2942C-0.0976249 14.6842 -0.0976249 15.3162 0.293375 15.7072ZM2.18138 7.99925C2.95837 6.83525 5.14637 4.00025 8.00037 4.00025C8.74237 4.00025 9.43738 4.20125 10.0784 4.50825L8.51237 6.07425C8.34838 6.02925 8.17838 6.00025 8.00037 6.00025C6.89537 6.00025 6.00038 6.89525 6.00038 8.00025C6.00038 8.17825 6.02938 8.34825 6.07438 8.51225L4.24038 10.3462C3.28538 9.51025 2.55938 8.56225 2.18138 7.99925Z"
							fill="currentColor"
						></path>
					</g>
					<g id="mpa-eyesight--filled--off">
						<path
							d="M14.6 5.60001L6.39999 13.8C6.89999 13.9 7.49999 14 7.99999 14C11.6 14 14.4 10.9 15.6 9.10001C16.1 8.40001 16.1 7.50001 15.6 6.80001C15.4 6.50001 15 6.10001 14.6 5.60001Z"
							fill="currentColor"
						></path>
						<path
							d="M14.3 0.3L11.6 3C10.5 2.4 9.3 2 8 2C4.4 2 1.6 5.1 0.4 6.9C-0.1 7.6 -0.1 8.5 0.4 9.1C0.9 9.9 1.8 10.9 2.8 11.8L0.3 14.3C-0.1 14.7 -0.1 15.3 0.3 15.7C0.5 15.9 0.7 16 1 16C1.3 16 1.5 15.9 1.7 15.7L15.7 1.7C16.1 1.3 16.1 0.7 15.7 0.3C15.3 -0.1 14.7 -0.1 14.3 0.3ZM5.3 9.3C5.1 8.9 5 8.5 5 8C5 6.3 6.3 5 8 5C8.5 5 8.9 5.1 9.3 5.3L5.3 9.3Z"
							fill="currentColor"
						></path>
					</g>
					<g id="mpa-eyesight--outline--on">
						<path
							d="M8.00013 14C12.7071 14 15.7441 8.716 15.8711 8.492C16.0421 8.188 16.0431 7.816 15.8721 7.512C15.7461 7.287 12.7311 2 8.00013 2C3.24513 2 0.251127 7.289 0.126127 7.514C-0.0428725 7.817 -0.0418725 8.186 0.128127 8.489C0.254128 8.713 3.26913 14 8.00013 14ZM8.00013 4C10.8391 4 13.0361 6.835 13.8181 8C13.0341 9.166 10.8371 12 8.00013 12C5.15913 12 2.96213 9.162 2.18113 7.999C2.95813 6.835 5.14613 4 8.00013 4Z"
							fill="currentColor"
						></path>
						<path
							d="M8 11C9.65685 11 11 9.65685 11 8C11 6.34315 9.65685 5 8 5C6.34315 5 5 6.34315 5 8C5 9.65685 6.34315 11 8 11Z"
							fill="currentColor"
						></path>
					</g>
					<g id="mpa-eyesight--filled--on">
						<path
							d="M7.975 14C11.575 14 14.375 10.9 15.575 9.1C16.075 8.4 16.075 7.5 15.575 6.8C14.375 5.1 11.575 2 7.975 2C4.375 2 1.575 5.1 0.375 6.9C-0.125 7.6 -0.125 8.5 0.375 9.1C1.575 10.9 4.375 14 7.975 14ZM7.975 5C9.675 5 10.975 6.3 10.975 8C10.975 9.7 9.675 11 7.975 11C6.275 11 4.975 9.7 4.975 8C4.975 6.3 6.275 5 7.975 5Z"
							fill="currentColor"
						></path>
					</g>
					<g id="mpa-filter--outline">
						<path
							d="M15 3.16048C15 3.47872 14.8485 3.77795 14.5921 3.96637L9.96348 7.36697C9.70702 7.55539 9.55556 7.85462 9.55556 8.17285V13.0073C9.55556 13.4073 9.31716 13.7688 8.94947 13.9264L7.83836 14.4026C7.1785 14.6854 6.44444 14.2014 6.44444 13.4835V8.17285C6.44444 7.85462 6.29298 7.55539 6.03652 7.36697L1.40792 3.96637C1.15147 3.77795 1 3.47872 1 3.16048V2C1 1.44772 1.44772 1 2 1H14C14.5523 1 15 1.44772 15 2V3.16048Z"
							stroke="currentColor"
							strokeWidth="2"
							strokeMiterlimit="10"
							strokeLinecap="square"
						></path>
					</g>
					<g id="mpa-filter--filled">
						<path
							d="M15 0H1C0.4 0 0 0.4 0 1V3C0 3.3 0.1 3.6 0.4 3.8L6 8.5V15C6 15.4 6.2 15.8 6.6 15.9C6.7 16 6.9 16 7 16C7.3 16 7.5 15.9 7.7 15.7L9.7 13.7C9.9 13.5 10 13.3 10 13V8.5L15.6 3.8C15.9 3.6 16 3.3 16 3V1C16 0.4 15.6 0 15 0Z"
							fill="currentColor"
						></path>
					</g>
					<g id="mpa-minus--line">
						<path
							d="M0 7.85715V8.14286C0 8.69515 0.447715 9.14286 1 9.14286H15C15.5523 9.14286 16 8.69515 16 8.14286V7.85715C16 7.30486 15.5523 6.85715 15 6.85715H1C0.447715 6.85715 0 7.30486 0 7.85715Z"
							fill="currentColor"
						></path>
					</g>
					<g id="mpa-minus--outline">
						<circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="2"></circle>
						<path
							d="M4 8.5V7.5C4 7.22386 4.22386 7 4.5 7H11.5C11.7761 7 12 7.22386 12 7.5V8.5C12 8.77614 11.7761 9 11.5 9H4.5C4.22386 9 4 8.77614 4 8.5Z"
							fill="currentColor"
						></path>
					</g>
					<g id="mpa-minus--filled">
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM4.5 7C4.22386 7 4 7.22386 4 7.5V8.5C4 8.77614 4.22386 9 4.5 9H11.5C11.7761 9 12 8.77614 12 8.5V7.5C12 7.22386 11.7761 7 11.5 7L4.5 7Z"
							fill="currentColor"
						></path>
					</g>
					<g id="mpa-plus--line">
						<path
							d="M16 8.14286C16 8.69514 15.5523 9.14286 15 9.14286H9.14286V15C9.14286 15.5523 8.69514 16 8.14286 16H7.85714C7.30486 16 6.85714 15.5523 6.85714 15V9.14286H1C0.447715 9.14286 0 8.69514 0 8.14286V7.85714C0 7.30486 0.447715 6.85714 1 6.85714H6.85714V1C6.85714 0.447715 7.30486 0 7.85714 0H8.14286C8.69514 0 9.14286 0.447715 9.14286 1V6.85714H15C15.5523 6.85714 16 7.30486 16 7.85714V8.14286Z"
							fill="currentColor"
						></path>
					</g>
					<g id="mpa-plus--outline">
						<circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="2"></circle>
						<path
							d="M4.5 7H7V4.5C7 4.22386 7.22386 4 7.5 4H8.5C8.77614 4 9 4.22386 9 4.5V7H11.5C11.7761 7 12 7.22386 12 7.5V8.5C12 8.77614 11.7761 9 11.5 9H9V11.5C9 11.7761 8.77614 12 8.5 12H7.5C7.22386 12 7 11.7761 7 11.5V9H4.5C4.22386 9 4 8.77614 4 8.5V7.5C4 7.22386 4.22386 7 4.5 7Z"
							fill="currentColor"
						></path>
					</g>
					<g id="mpa-plus--filled">
						<path
							fillRule="evenodd"
							d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM7 7H4.5C4.22386 7 4 7.22386 4 7.5V8.5C4 8.77614 4.22386 9 4.5 9H7V11.5C7 11.7761 7.22386 12 7.5 12H8.5C8.77614 12 9 11.7761 9 11.5V9H11.5C11.7761 9 12 8.77614 12 8.5V7.5C12 7.22386 11.7761 7 11.5 7H9V4.5C9 4.22386 8.77614 4 8.5 4L7.5 4C7.22386 4 7 4.22386 7 4.5V7Z"
							fill="currentColor"
						></path>
					</g>
					<g id="mpa-remove">
						<path
							d="M19.586 0.428571C19.0141 -0.142857 18.1564 -0.142857 17.5845 0.428571L10.0074 8L2.43038 0.428571C1.85853 -0.142857 1.00074 -0.142857 0.42889 0.428571C-0.142964 1 -0.142964 1.85714 0.42889 2.42857L8.00595 10L0.42889 17.5714C-0.142964 18.1429 -0.142964 19 0.42889 19.5714C0.714817 19.8571 1.00074 20 1.42963 20C1.85853 20 2.14445 19.8571 2.43038 19.5714L10.0074 12L17.5845 19.5714C17.8704 19.8571 18.2993 20 18.5853 20C18.8712 20 19.3001 19.8571 19.586 19.5714C20.1578 19 20.1578 18.1429 19.586 17.5714L12.0089 10L19.586 2.42857C20.1578 1.85714 20.1578 1 19.586 0.428571Z"
							fill="currentColor"
						></path>
					</g>
					<g id="mpa-swap">
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M5.53598 18.7459C7.09743 19.7676 8.92251 20.3199 10.7845 20.3199C16.1971 20.3199 20.6002 15.7623 20.6002 10.1599C20.6002 4.55758 16.1971 0 10.7845 0C5.63795 0 1.40399 4.12068 1.00032 9.34205C0.9655 9.79246 1.33505 10.1599 1.7868 10.1599C2.23856 10.1599 2.60076 9.79265 2.64256 9.34284C3.04095 5.05624 6.54048 1.69332 10.7845 1.69332C15.2948 1.69332 18.9643 5.49145 18.9643 10.1599C18.9643 14.8284 15.2948 18.6266 10.7845 18.6266C9.22645 18.6266 7.70006 18.1624 6.39587 17.3047L7.71056 17.0612C8.16986 16.9761 8.4777 16.534 8.39813 16.0737C8.31856 15.6134 7.88171 15.3093 7.42241 15.3943L4.25458 15.9811L4.24312 15.9833L4.22789 15.9859C3.7832 16.0683 3.48516 16.4963 3.5622 16.942L4.14767 20.3287C4.2247 20.7743 4.64765 21.0688 5.09234 20.9865C5.53704 20.9041 5.83508 20.4761 5.75804 20.0304L5.53598 18.7459Z"
							fill="currentColor"
						></path>
					</g>
					<g id="mpa-arrows">
						<path
							d="M15.829 7.55346L13.829 5.33123C13.7707 5.26579 13.7 5.21249 13.6211 5.17438C13.5422 5.13627 13.4565 5.11411 13.369 5.10916C13.2814 5.1042 13.1938 5.11656 13.1111 5.14551C13.0283 5.17447 12.9521 5.21945 12.8868 5.2779C12.7567 5.39693 12.6783 5.5621 12.6683 5.73815C12.6584 5.9142 12.7176 6.08717 12.8335 6.22012L13.8735 7.37568H8.62012V2.12234L9.77568 3.16234C9.84101 3.22079 9.91722 3.26578 9.99996 3.29473C10.0827 3.32369 10.1703 3.33604 10.2578 3.33109C10.3454 3.32613 10.431 3.30397 10.51 3.26586C10.5889 3.22776 10.6596 3.17445 10.7179 3.10901C10.8337 2.97606 10.893 2.80309 10.883 2.62704C10.8731 2.45099 10.7947 2.28581 10.6646 2.16679L8.44234 0.166788C8.31925 0.0592572 8.16135 0 7.9979 0C7.83445 0 7.67655 0.0592572 7.55345 0.166788L5.33123 2.16679C5.19921 2.28466 5.11943 2.45015 5.10943 2.62685C5.09942 2.80355 5.16003 2.97699 5.2779 3.10901C5.39577 3.24103 5.56126 3.32082 5.73796 3.33082C5.91467 3.34082 6.0881 3.28022 6.22012 3.16234L7.37568 2.12234V7.37568H2.12234L3.16234 6.22012C3.27818 6.08717 3.33745 5.9142 3.32748 5.73815C3.31752 5.5621 3.23911 5.39693 3.10901 5.2779C3.04368 5.21945 2.96747 5.17447 2.88473 5.14551C2.80199 5.11656 2.71436 5.1042 2.62684 5.10916C2.53932 5.11411 2.45364 5.13627 2.3747 5.17438C2.29576 5.21249 2.22511 5.26579 2.16679 5.33123L0.166788 7.55346C0.0592572 7.67655 0 7.83445 0 7.9979C0 8.16135 0.0592572 8.31925 0.166788 8.44234L2.16679 10.6646C2.22511 10.73 2.29576 10.7833 2.3747 10.8214C2.45364 10.8595 2.53932 10.8817 2.62684 10.8866C2.71436 10.8916 2.80199 10.8792 2.88473 10.8503C2.96747 10.8213 3.04368 10.7763 3.10901 10.7179C3.23911 10.5989 3.31752 10.4337 3.32748 10.2576C3.33745 10.0816 3.27818 9.90862 3.16234 9.77568L2.12234 8.62012H7.37568V13.8735L6.22012 12.8335C6.0881 12.7156 5.91467 12.655 5.73796 12.665C5.56126 12.675 5.39577 12.7548 5.2779 12.8868C5.16003 13.0188 5.09942 13.1922 5.10943 13.3689C5.11943 13.5456 5.19921 13.7111 5.33123 13.829L7.55345 15.829C7.67568 15.9383 7.83391 15.9988 7.9979 15.9988C8.16188 15.9988 8.32012 15.9383 8.44234 15.829L10.6646 13.829C10.7299 13.7706 10.7832 13.7 10.8212 13.621C10.8593 13.5421 10.8814 13.4564 10.8864 13.3689C10.8913 13.2815 10.879 13.1938 10.8501 13.1111C10.8212 13.0284 10.7763 12.9522 10.7179 12.8868C10.6595 12.8214 10.5889 12.7682 10.5099 12.7301C10.431 12.6921 10.3453 12.6699 10.2578 12.665C10.1703 12.66 10.0827 12.6724 10 12.7013C9.91727 12.7302 9.84105 12.7751 9.77568 12.8335L8.62012 13.8735V8.62012H13.8735L12.8335 9.77568C12.7176 9.90862 12.6584 10.0816 12.6683 10.2576C12.6783 10.4337 12.7567 10.5989 12.8868 10.7179C12.9521 10.7763 13.0283 10.8213 13.1111 10.8503C13.1938 10.8792 13.2814 10.8916 13.369 10.8866C13.4565 10.8817 13.5422 10.8595 13.6211 10.8214C13.7 10.7833 13.7707 10.73 13.829 10.6646L15.829 8.44234C15.9365 8.31925 15.9958 8.16135 15.9958 7.9979C15.9958 7.83445 15.9365 7.67655 15.829 7.55346Z"
							fill="currentColor"
						></path>
					</g>
					<g id="mpa-expand">
						<path
							d="M9.0001 2H12.6001L8.6001 6L10.0001 7.4L14.0001 3.4V7H16.0001V0H9.0001V2Z"
							fill="currentColor"
						></path>
						<path
							d="M6 8.6001L2 12.6001V9.0001H0V16.0001H7V14.0001H3.4L7.4 10.0001L6 8.6001Z"
							fill="currentColor"
						></path>
					</g>
					<g id="mpa-bag">
						<path
							d="M14.0001 15.0002H2L3.20001 4.81819H12.8001L14.0001 15.0002Z"
							stroke="currentColor"
							strokeWidth="1.5"
							strokeMiterlimit="10"
							strokeLinecap="square"
						></path>
						<path
							d="M6.12476 7.12512V3.72227C6.12476 2.22502 7.05289 1 8.18728 1C9.32167 1 10.2498 2.22502 10.2498 3.72227V7.12512"
							stroke="currentColor"
							strokeWidth="1.5"
							strokeMiterlimit="10"
							strokeLinecap="square"
						></path>
					</g>
					<g id="mpa-bars">
						<path
							fillRule="evenodd"
							d="M0 12.7778C0 13.2687 0.397969 13.6667 0.888889 13.6667H15.1111C15.602 13.6667 16 13.2687 16 12.7778C16 12.2869 15.602 11.8889 15.1111 11.8889H0.888889C0.397969 11.8889 0 12.2869 0 12.7778ZM0 8.33333C0 8.82425 0.397969 9.22222 0.888889 9.22222H15.1111C15.602 9.22222 16 8.82425 16 8.33333C16 7.84241 15.602 7.44444 15.1111 7.44444H0.888889C0.397969 7.44444 0 7.84241 0 8.33333ZM0.888889 3C0.397969 3 0 3.39797 0 3.88889C0 4.37981 0.397969 4.77778 0.888889 4.77778H15.1111C15.602 4.77778 16 4.37981 16 3.88889C16 3.39797 15.602 3 15.1111 3H0.888889Z"
							fill="currentColor"
						></path>
					</g>
					<g id="mpa-cog">
						<path
							d="M15.135 6.784C13.832 6.458 13.214 4.966 13.905 3.815C14.227 3.279 14.13 2.817 13.811 2.499L13.501 2.189C13.183 1.871 12.721 1.774 12.185 2.095C11.033 2.786 9.541 2.168 9.216 0.865C9.065 0.258 8.669 0 8.219 0H7.781C7.331 0 6.936 0.258 6.784 0.865C6.458 2.168 4.966 2.786 3.815 2.095C3.279 1.773 2.816 1.87 2.498 2.188L2.188 2.498C1.87 2.816 1.773 3.279 2.095 3.815C2.786 4.967 2.168 6.459 0.865 6.784C0.26 6.935 0 7.33 0 7.781V8.219C0 8.669 0.258 9.064 0.865 9.216C2.168 9.542 2.786 11.034 2.095 12.185C1.773 12.721 1.87 13.183 2.189 13.501L2.499 13.811C2.818 14.13 3.281 14.226 3.815 13.905C4.967 13.214 6.459 13.832 6.784 15.135C6.935 15.742 7.331 16 7.781 16H8.219C8.669 16 9.064 15.742 9.216 15.135C9.542 13.832 11.034 13.214 12.185 13.905C12.72 14.226 13.182 14.13 13.501 13.811L13.811 13.501C14.129 13.183 14.226 12.721 13.905 12.185C13.214 11.033 13.832 9.541 15.135 9.216C15.742 9.065 16 8.669 16 8.219V7.781C16 7.33 15.74 6.935 15.135 6.784ZM8 11C6.343 11 5 9.657 5 8C5 6.343 6.343 5 8 5C9.657 5 11 6.343 11 8C11 9.657 9.657 11 8 11Z"
							fill="currentColor"
						></path>
					</g>
					<g id="mpa-columns">
						<path d="M1 4H15V15H1V4Z" stroke="currentColor" strokeWidth="2"></path>
						<path d="M0 1C0 0.447715 0.447715 0 1 0H15C15.5523 0 16 0.447715 16 1V5H0V1Z" fill="currentColor"></path>
						<line x1="8.11108" y1="4.70586" x2="8.11108" y2="14.1176" stroke="currentColor" strokeWidth="2"></line>
					</g>
					<g id="mpa-credit-card">
						<path
							d="M13.7142 3.49469C13.8938 3.49469 14.1326 3.56604 14.2596 3.69305C14.3866 3.82006 14.487 3.99232 14.487 4.17194L14.5051 11.2408C14.5051 11.4204 14.4338 11.5927 14.3068 11.7197C14.1798 11.8467 14.0075 11.918 13.8279 11.918L2.30637 11.9181C2.12676 11.9181 1.95449 11.8467 1.82749 11.7197C1.70048 11.5927 1.62912 11.4205 1.62912 11.2408L1.58197 4.172C1.58197 3.99238 1.65333 3.82012 1.78033 3.69311C1.90734 3.56611 2.0796 3.49475 2.25922 3.49475L13.7142 3.49469ZM14.3177 2L1.75127 2.00006C1.30223 2.00006 0.871578 2.17845 0.554056 2.49597C0.236534 2.81349 0 3.24414 0 3.69319L0.0472208 11.8334C0.0472208 12.2825 0.225603 12.7131 0.543125 13.0306C0.860646 13.3482 1.2913 13.5266 1.74034 13.5266L14.3068 13.5265C14.7558 13.5265 15.1865 13.3481 15.504 13.0306C15.8215 12.7131 15.9999 12.2824 15.9999 11.8334L16.0108 3.69312C16.0108 3.24408 15.8325 2.81343 15.5149 2.4959C15.1974 2.17838 14.7668 2 14.3177 2ZM13.4139 5.18788C13.4139 5.00826 13.3426 4.836 13.2156 4.70899C13.0886 4.58198 12.9163 4.51063 12.7367 4.51063H10.2682C10.0885 4.51063 9.91629 4.58198 9.78928 4.70899C9.66227 4.836 9.59092 5.00826 9.59092 5.18788C9.59092 5.36749 9.66227 5.53975 9.78928 5.66676C9.91629 5.79377 10.0885 5.86512 10.2682 5.86512H12.7367C12.9163 5.86512 13.0886 5.79377 13.2156 5.66676C13.3426 5.53975 13.4139 5.36749 13.4139 5.18788ZM3.91809 9.58997C3.91899 9.53426 3.90879 9.47893 3.88809 9.42721C3.86739 9.37548 3.83661 9.32839 3.79753 9.28868C3.75845 9.24896 3.71185 9.21743 3.66046 9.1959C3.60907 9.17438 3.55391 9.1633 3.4982 9.16331H2.84384C2.78376 9.15569 2.72275 9.16095 2.66486 9.17874C2.60697 9.19653 2.55353 9.22644 2.5081 9.26648C2.46266 9.30652 2.42627 9.35578 2.40134 9.41097C2.37642 9.46616 2.36352 9.52603 2.36352 9.58659C2.36352 9.64715 2.37642 9.70701 2.40134 9.76221C2.42627 9.8174 2.46266 9.86665 2.5081 9.90669C2.55353 9.94673 2.60697 9.97664 2.66486 9.99443C2.72275 10.0122 2.78376 10.0175 2.84384 10.0099H3.4982C3.55334 10.0099 3.60794 9.99901 3.65888 9.9779C3.70983 9.9568 3.75611 9.92587 3.79511 9.88688C3.8341 9.84789 3.86503 9.8016 3.88613 9.75066C3.90723 9.69972 3.91809 9.64511 3.91809 9.58997ZM10.5806 9.58896C10.5815 9.53325 10.5713 9.47792 10.5506 9.42619C10.5299 9.37446 10.4991 9.32737 10.46 9.28766C10.4209 9.24795 10.3743 9.21641 10.3229 9.19489C10.2715 9.17336 10.2164 9.16228 10.1607 9.16229L9.39853 9.1661C9.33845 9.15848 9.27744 9.16374 9.21955 9.18153C9.16166 9.19932 9.10822 9.22923 9.06279 9.26927C9.01735 9.30931 8.98096 9.35857 8.95604 9.41376C8.93111 9.46895 8.91822 9.52882 8.91822 9.58938C8.91822 9.64994 8.93111 9.7098 8.95604 9.765C8.98096 9.82019 9.01735 9.86944 9.06279 9.90948C9.10822 9.94952 9.16166 9.97943 9.21955 9.99722C9.27744 10.015 9.33845 10.0203 9.39853 10.0127L10.1607 10.0088C10.272 10.0088 10.3788 9.96461 10.4576 9.88587C10.5363 9.80712 10.5806 9.70032 10.5806 9.58896ZM8.26409 9.59276C8.2641 9.48077 8.22008 9.37326 8.14152 9.29343C8.06296 9.21361 7.95617 9.16787 7.84419 9.1661L7.12468 9.16568C7.0646 9.15806 7.00359 9.16332 6.9457 9.18111C6.88781 9.1989 6.83437 9.22881 6.78894 9.26885C6.7435 9.30889 6.70711 9.35814 6.68218 9.41334C6.65726 9.46853 6.64436 9.5284 6.64436 9.58896C6.64436 9.64952 6.65726 9.70938 6.68218 9.76458C6.70711 9.81977 6.7435 9.86902 6.78894 9.90906C6.83437 9.9491 6.88781 9.97901 6.9457 9.9968C7.00359 10.0146 7.0646 10.0199 7.12468 10.0122L7.84419 10.0127C7.95555 10.0127 8.06236 9.96842 8.1411 9.88967C8.21985 9.81093 8.26409 9.70413 8.26409 9.59276ZM6.0303 9.59234C6.0303 9.47918 5.98534 9.37066 5.90533 9.29064C5.82531 9.21063 5.71679 9.16568 5.60363 9.16568L4.87065 9.16331C4.76761 9.17637 4.67287 9.22657 4.60419 9.30449C4.53552 9.38242 4.49763 9.48272 4.49763 9.58659C4.49763 9.69045 4.53552 9.79075 4.60419 9.86868C4.67287 9.94661 4.76761 9.99681 4.87065 10.0099L5.60363 10.0122C5.71562 10.0122 5.82313 9.96823 5.90296 9.88967C5.98278 9.81112 6.02852 9.70432 6.0303 9.59234Z"
							fill="currentColor"
						></path>
					</g>
					<g id="mpa-elypsis">
						<circle cx="7.77778" cy="1.77778" r="1.77778" fill="currentColor"></circle>
						<circle cx="7.77778" cy="8.00001" r="1.77778" fill="currentColor"></circle>
						<circle cx="7.77778" cy="14.2222" r="1.77778" fill="currentColor"></circle>
					</g>
					<g id="mpa-exchange">
						<path
							d="M15.8173 5.29688L12.9284 8.39911C12.866 8.4664 12.7904 8.52009 12.7062 8.5568C12.6221 8.59351 12.5313 8.61245 12.4395 8.61244C12.2716 8.6116 12.11 8.54821 11.9862 8.43466C11.8635 8.30854 11.7948 8.13952 11.7948 7.96355C11.7948 7.78758 11.8635 7.61856 11.9862 7.49244L13.8351 5.50133H0.990643V4.17688H13.7995L11.9506 2.17688C11.8779 2.1157 11.8191 2.03967 11.7781 1.95389C11.7372 1.86811 11.715 1.77456 11.7132 1.67952C11.7114 1.58448 11.7299 1.49015 11.7675 1.40285C11.8051 1.31556 11.861 1.23731 11.9313 1.17337C12.0016 1.10943 12.0848 1.06127 12.1753 1.03212C12.2658 1.00297 12.3614 0.993506 12.4559 1.00436C12.5503 1.01522 12.6413 1.04614 12.7228 1.09506C12.8043 1.14398 12.8744 1.20976 12.9284 1.28799L15.8173 4.39911C15.931 4.52092 15.9943 4.68135 15.9943 4.848C15.9943 5.01464 15.931 5.17508 15.8173 5.29688ZM4.03953 9.288C4.11228 9.22681 4.1711 9.15078 4.21206 9.065C4.25301 8.97922 4.27515 8.88567 4.27698 8.79063C4.27881 8.69559 4.2603 8.60126 4.22268 8.51397C4.18507 8.42667 4.12922 8.34843 4.05888 8.28448C3.98855 8.22054 3.90535 8.17238 3.81488 8.14323C3.7244 8.11408 3.62874 8.10462 3.5343 8.11547C3.43987 8.12633 3.34885 8.15725 3.26735 8.20617C3.18584 8.25509 3.11575 8.32087 3.06175 8.39911L0.172865 11.5013C0.0616785 11.6226 0 11.7812 0 11.9458C0 12.1103 0.0616785 12.2689 0.172865 12.3902L3.06175 15.5102C3.12417 15.5775 3.19981 15.6312 3.28393 15.6679C3.36806 15.7046 3.45886 15.7236 3.55064 15.7236C3.7186 15.7227 3.88022 15.6593 4.00398 15.5458C4.12669 15.4197 4.19535 15.2506 4.19535 15.0747C4.19535 14.8987 4.12669 14.7297 4.00398 14.6036L2.19064 12.6213H14.9995V11.288H2.19064L4.03953 9.288Z"
							fill="currentColor"
						></path>
					</g>
					<g id="mpa-export">
						<path
							d="M15 16H1C0.4 16 0 15.6 0 15V9H2V14H14V4H12V2H15C15.6 2 16 2.4 16 3V15C16 15.6 15.6 16 15 16Z"
							fill="currentColor"
						></path>
						<path d="M6 3C9.2 3 12 5.5 12 10C10.9 8.3 9.6 7 6 7V10L0 5L6 0V3Z" fill="currentColor"></path>
					</g>
					<g id="mpa-link">
						<path
							d="M11 0C9.7 0 8.4 0.5 7.5 1.5L6.3 2.6C5.9 3 5.9 3.6 6.3 4C6.7 4.4 7.3 4.4 7.7 4L8.9 2.8C10 1.7 12 1.7 13.1 2.8C13.7 3.4 14 4.2 14 5C14 5.8 13.7 6.6 13.1 7.1L12 8.3C11.6 8.7 11.6 9.3 12 9.7C12.2 9.9 12.5 10 12.7 10C12.9 10 13.2 9.9 13.4 9.7L14.6 8.5C15.5 7.6 16 6.3 16 5C16 3.7 15.5 2.4 14.5 1.5C13.6 0.5 12.3 0 11 0Z"
							fill="currentColor"
						></path>
						<path
							d="M8.3 12L7.1 13.2C6 14.3 4 14.3 2.9 13.2C2.3 12.6 2 11.8 2 11C2 10.2 2.3 9.4 2.9 8.9L4 7.7C4.4 7.3 4.4 6.7 4 6.3C3.6 5.9 3 5.9 2.6 6.3L1.5 7.5C0.5 8.4 0 9.7 0 11C0 12.3 0.5 13.6 1.5 14.5C2.4 15.5 3.7 16 5 16C6.3 16 7.6 15.5 8.5 14.5L9.7 13.3C10.1 12.9 10.1 12.3 9.7 11.9C9.3 11.5 8.7 11.6 8.3 12Z"
							fill="currentColor"
						></path>
						<path
							d="M9.39999 5.19999L5.19999 9.39999C4.79999 9.79999 4.79999 10.4 5.19999 10.8C5.39999 11 5.69999 11.1 5.89999 11.1C6.09999 11.1 6.39999 11 6.59999 10.8L10.8 6.59999C11.2 6.19999 11.2 5.59999 10.8 5.19999C10.4 4.79999 9.79999 4.79999 9.39999 5.19999Z"
							fill="currentColor"
						></path>
					</g>
					<g id="mpa-settings">
						<path
							d="M3.79999 4.73334V1"
							stroke="currentColor"
							strokeMiterlimit="10"
							strokeLinecap="round"
							strokeLinejoin="round"
						></path>
						<path
							d="M3.79999 15V13.1334"
							stroke="currentColor"
							strokeMiterlimit="10"
							strokeLinecap="round"
							strokeLinejoin="round"
						></path>
						<path
							d="M12.2 11.2667V15"
							stroke="currentColor"
							strokeMiterlimit="10"
							strokeLinecap="round"
							strokeLinejoin="round"
						></path>
						<path
							d="M12.2 1V2.86667"
							stroke="currentColor"
							strokeMiterlimit="10"
							strokeLinecap="round"
							strokeLinejoin="round"
						></path>
						<path
							d="M3.8 13.1333C5.3464 13.1333 6.60001 11.8797 6.60001 10.3333C6.60001 8.78695 5.3464 7.53334 3.8 7.53334C2.2536 7.53334 1 8.78695 1 10.3333C1 11.8797 2.2536 13.1333 3.8 13.1333Z"
							stroke="currentColor"
							strokeMiterlimit="10"
							strokeLinecap="round"
							strokeLinejoin="round"
						></path>
						<path
							d="M12.2 8.46668C13.7464 8.46668 15 7.21307 15 5.66667C15 4.12027 13.7464 2.86667 12.2 2.86667C10.6536 2.86667 9.40002 4.12027 9.40002 5.66667C9.40002 7.21307 10.6536 8.46668 12.2 8.46668Z"
							stroke="currentColor"
							strokeMiterlimit="10"
							strokeLinecap="round"
							strokeLinejoin="round"
						></path>
					</g>
					<g id="mpa-store">
						<path
							d="M12.6667 1H3.33333L1 5.2C1 6.48893 2.0444 7.53333 3.33333 7.53333C4.62227 7.53333 5.66667 6.48893 5.66667 5.2C5.66667 6.48893 6.71107 7.53333 8 7.53333C9.28893 7.53333 10.3333 6.48893 10.3333 5.2C10.3333 6.48893 11.3777 7.53333 12.6667 7.53333C13.9556 7.53333 15 6.48893 15 5.2L12.6667 1Z"
							stroke="currentColor"
							strokeWidth="1.5"
							strokeMiterlimit="10"
							strokeLinecap="round"
							strokeLinejoin="round"
						></path>
						<path
							d="M13.25 9.75V15H2.75V9.75"
							stroke="currentColor"
							strokeWidth="1.5"
							strokeMiterlimit="10"
							strokeLinecap="round"
							strokeLinejoin="round"
						></path>
						<path
							d="M6.59999 15V11.2667H9.39999V15"
							stroke="currentColor"
							strokeWidth="1.5"
							strokeMiterlimit="10"
							strokeLinecap="round"
							strokeLinejoin="round"
						></path>
					</g>
					<g id="mpa-angle--down">
						<path
							d="M4 6L8.5 10.5L13 6"
							stroke="currentColor"
							strokeMiterlimit="10"
							strokeLinecap="round"
							strokeLinejoin="round"
						></path>
					</g>
					<g id="mpa-angle--up">
						<path
							d="M13 10L8.5 5.5L4 10"
							stroke="currentColor"
							strokeMiterlimit="10"
							strokeLinecap="round"
							strokeLinejoin="round"
						></path>
					</g>
					<g id="mpa-location-input">
						<path
							d="M9 0C4.05 0 0 4.05 0 9C0 13.95 4.05 18 9 18C13.95 18 18 13.95 18 9C18 4.05 13.95 0 9 0ZM10.125 10.125L7.875 14.625L5.625 5.625L14.625 7.875L10.125 10.125Z"
							fill="currentColor"
						></path>
					</g>
					<g id="inf-star">
						<path
							d="M7.369,11.251,11.923,14,10.714,8.82l4.023-3.485-5.3-.449L7.369,0,5.3,4.885,0,5.335,4.023,8.82,2.815,14Z"
							fill="currentColor"
						></path>
					</g>
					<g id="inf-help--outline">
						<path
							d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM8 14C4.7 14 2 11.3 2 8C2 4.7 4.7 2 8 2C11.3 2 14 4.7 14 8C14 11.3 11.3 14 8 14Z"
							fill="currentColor"
						></path>
						<path
							d="M8 13C8.55228 13 9 12.5523 9 12C9 11.4477 8.55228 11 8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13Z"
							fill="currentColor"
						></path>
						<path
							d="M7.09999 5.5C7.29999 5.2 7.59999 5 7.99999 5C8.59999 5 8.99999 5.4 8.99999 6C8.99999 6.3 8.89999 6.4 8.39999 6.7C7.79999 7.1 6.99999 7.7 6.99999 9V10H8.99999V9C8.99999 8.8 8.99999 8.7 9.49999 8.4C10.1 8 11 7.4 11 6C11 4.3 9.69999 3 7.99999 3C6.89999 3 5.89999 3.6 5.39999 4.5L4.89999 5.4L6.59999 6.4L7.09999 5.5Z"
							fill="currentColor"
						></path>
					</g>
					<g id="inf-help--filled">
						<path
							d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM8 13C7.4 13 7 12.6 7 12C7 11.4 7.4 11 8 11C8.6 11 9 11.4 9 12C9 12.6 8.6 13 8 13ZM9.5 8.4C9 8.7 9 8.8 9 9V10H7V9C7 7.7 7.8 7.1 8.4 6.7C8.9 6.4 9 6.3 9 6C9 5.4 8.6 5 8 5C7.6 5 7.3 5.2 7.1 5.5L6.6 6.4L4.9 5.4L5.4 4.5C5.9 3.6 6.9 3 8 3C9.7 3 11 4.3 11 6C11 7.4 10.1 8 9.5 8.4Z"
							fill="currentColor"
						></path>
					</g>
					<g id="inf-tooltip--outline">
						<path
							d="M8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16ZM8 2C11.3 2 14 4.7 14 8C14 11.3 11.3 14 8 14C4.7 14 2 11.3 2 8C2 4.7 4.7 2 8 2Z"
							fill="currentColor"
						></path>
						<path d="M7 12H9V7H7L7 12Z" fill="currentColor"></path>
						<path
							d="M8 4C7.44772 4 7 4.44772 7 5C7 5.55228 7.44772 6 8 6C8.55228 6 9 5.55228 9 5C9 4.44772 8.55228 4 8 4Z"
							fill="currentColor"
						></path>
					</g>
					<g id="inf-tooltip--filled">
						<path
							d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM9 12H7V7H9V12ZM8 6C7.4 6 7 5.6 7 5C7 4.4 7.4 4 8 4C8.6 4 9 4.4 9 5C9 5.6 8.6 6 8 6Z"
							fill="currentColor"
						></path>
					</g>
					<g id="inf-warning--outline">
						<path
							d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM8 14C4.7 14 2 11.3 2 8C2 4.7 4.7 2 8 2C11.3 2 14 4.7 14 8C14 11.3 11.3 14 8 14Z"
							fill="currentColor"
						></path>
						<path d="M9 4H7V9H9V4Z" fill="currentColor"></path>
						<path
							d="M8 12C8.55228 12 9 11.5523 9 11C9 10.4477 8.55228 10 8 10C7.44772 10 7 10.4477 7 11C7 11.5523 7.44772 12 8 12Z"
							fill="currentColor"
						></path>
					</g>
					<g id="inf-warning--filled">
						<path
							d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM8 12C7.4 12 7 11.6 7 11C7 10.4 7.4 10 8 10C8.6 10 9 10.4 9 11C9 11.6 8.6 12 8 12ZM9 9H7V4H9V9Z"
							fill="currentColor"
						></path>
					</g>
					<g id="nav-caret--down">
						<path
							d="M8.73746 13.1948C8.34108 13.6276 7.65892 13.6276 7.26254 13.1948L0 5.26471L2.07407 3L8 9.47059L13.9259 3L16 5.26471L8.73746 13.1948Z"
							fill="currentColor"
						></path>
					</g>
					<g id="nav-caret--left">
						<path
							d="M2.80524 8.73746C2.37243 8.34108 2.37243 7.65892 2.80525 7.26254L10.7353 0L13 2.07407L6.52941 8L13 13.9259L10.7353 16L2.80524 8.73746Z"
							fill="currentColor"
						></path>
					</g>
					<g id="nav-caret--right">
						<path
							d="M12.1948 7.26254C12.6276 7.65892 12.6276 8.34108 12.1948 8.73746L4.26471 16L2 13.9259L8.47059 8L2 2.07407L4.26471 0L12.1948 7.26254Z"
							fill="currentColor"
						></path>
					</g>
					<g id="nav-caret--up">
						<path
							d="M7.26254 2.80524C7.65892 2.37243 8.34108 2.37243 8.73746 2.80525L16 10.7353L13.9259 13L8 6.52941L2.07407 13L0 10.7353L7.26254 2.80524Z"
							fill="currentColor"
						></path>
					</g>
					<g id="nav-thin-caret--left">
						<path
							d="M11 1L4 8L11 15"
							stroke="currentColor"
							strokeWidth="2"
							strokeMiterlimit="10"
							strokeLinecap="round"
							strokeLinejoin="round"
						></path>
					</g>
					<g id="nav-thin-caret--right">
						<path
							d="M5 15L12 8L5 1"
							stroke="currentColor"
							strokeWidth="2"
							strokeMiterlimit="10"
							strokeLinecap="round"
							strokeLinejoin="round"
						></path>
					</g>
					<g id="nav-arrow--left">
						<path
							d="M0.499992 7.5C0.499992 7.75781 0.583325 7.92969 0.749992 8.10156L5.49999 13L6.66666 11.7969L3.33332 8.35938L16.0002 8.35938V6.64063L3.33332 6.64063L6.66666 3.20313L5.49999 2L0.749992 6.89844C0.583325 7.07031 0.499992 7.24219 0.499992 7.5Z"
							fill="currentColor"
						></path>
					</g>
					<g id="nav-arrow--right">
						<path
							d="M16 8.5C16 8.75781 15.914 8.92969 15.7419 9.10156L10.8388 14L9.6345 12.7969L13.0753 9.35938L0 9.35938L0 7.64063L13.0753 7.64063L9.6345 4.20313L10.8388 3L15.7419 7.89844C15.914 8.07031 16 8.24219 16 8.5Z"
							fill="currentColor"
						></path>
					</g>
					<g id="nav-home">
						<path
							d="M 15.475000000000001 6.686111111111111 L 14.222222222222221 5.661111111111111 V 2.888888888888889 c 0 -0.12222222222222223 -0.1 -0.2222222222222222 -0.2222222222222222 -0.2222222222222222 h -0.8888888888888888 c -0.12222222222222223 0 -0.2222222222222222 0.1 -0.2222222222222222 0.2222222222222222 v 1.6805555555555556 L 8.705555555555556 1.1416666666666666 c -0.4083333333333333 -0.3361111111111111 -1 -0.3361111111111111 -1.4083333333333334 0 L 0.5249999999999999 6.686111111111111 c -0.09444444444444444 0.07777777777777778 -0.10833333333333334 0.21666666666666667 -0.030555555555555558 0.3138888888888889 l 0.5638888888888889 0.6888888888888889 c 0.07777777777777778 0.09444444444444444 0.21666666666666667 0.10833333333333334 0.3138888888888889 0.030555555555555558 l 0.4083333333333333 -0.3333333333333333 V 12.88888888888889 c 0 0.24444444444444446 0.2 0.4444444444444444 0.4444444444444444 0.4444444444444444 h 4.666666666666667 c 0.12222222222222223 0 0.2222222222222222 -0.1 0.2222222222222222 -0.2222222222222222 V 9.555555555555555 h 1.7777777777777777 v 3.5555555555555554 c 0 0.12222222222222223 0.1 0.2222222222222222 0.2222222222222222 0.2222222222222222 h 4.666666666666667 c 0.24444444444444446 0 0.4444444444444444 -0.2 0.4444444444444444 -0.4444444444444444 V 7.383333333333334 l 0.4083333333333333 0.3333333333333333 c 0.09444444444444444 0.07777777777777778 0.2361111111111111 0.06388888888888888 0.3138888888888889 -0.030555555555555558 l 0.5638888888888889 -0.6888888888888889 c 0.07222222222222223 -0.09444444444444444 0.058333333333333334 -0.23333333333333334 -0.036111111111111115 -0.3111111111111111 Z M 12.88888888888889 12 h -2.6666666666666665 V 8.444444444444445 c 0 -0.12222222222222223 -0.1 -0.2222222222222222 -0.2222222222222222 -0.2222222222222222 H 6 c -0.12222222222222223 0 -0.2222222222222222 0.1 -0.2222222222222222 0.2222222222222222 v 3.5555555555555554 h -2.6666666666666665 V 6.291666666666667 l 4.747222222222223 -3.888888888888889 c 0.08055555555555555 -0.06666666666666667 0.2 -0.06666666666666667 0.28055555555555556 0 l 4.747222222222223 3.888888888888889 V 12 Z"
							fill="currentColor"
						></path>
					</g>
					<g id="nav-plus">
						<path
							d="M15,7H9V1c0-0.6-0.4-1-1-1S7,0.4,7,1v6H1C0.4,7,0,7.4,0,8s0.4,1,1,1h6v6c0,0.6,0.4,1,1,1s1-0.4,1-1V9h6 c0.6,0,1-0.4,1-1S15.6,7,15,7z"
							fill="currentColor"
						></path>
					</g>
					<g id="nav-minus">
						<path d="M15,7H1C0.4,7,0,7.4,0,8s0.4,1,1,1h14c0.6,0,1-0.4,1-1S15.6,7,15,7z" fill="currentColor"></path>
					</g>
					<g id="sti-loading">
						<circle
							cx="50"
							opacity="0.4"
							cy="50"
							fill="none"
							stroke="#000000"
							r="40"
							className="c-muted-1"
							strokeWidth="14"
						></circle>
						<circle
							cx="50"
							cy="50"
							fill="none"
							stroke="#000000"
							r="40"
							strokeDasharray="60 900"
							strokeWidth="12"
							strokeLinecap="round"
						>
							<animateTransform
								attributeName="transform"
								attributeType="XML"
								dur="0.7s"
								type="rotate"
								from="0 50 50"
								to="360 50 50"
								repeatCount="indefinite"
							></animateTransform>
						</circle>
					</g>
					<g id="sti-check--line">
						<path
							d="M5.6 10L3.10711 7.50711C2.71658 7.11658 2.08342 7.11658 1.69289 7.50711L0.707107 8.49289C0.316583 8.88342 0.316583 9.51658 0.707107 9.90711L4.89289 14.0929C5.28342 14.4834 5.91658 14.4834 6.30711 14.0929L15.2929 5.10711C15.6834 4.71658 15.6834 4.08342 15.2929 3.69289L14.3071 2.70711C13.9166 2.31658 13.2834 2.31658 12.8929 2.70711L5.6 10Z"
							fill="currentColor"
						></path>
					</g>
					<g id="sti-check--outline">
						<path
							d="M8 0C3.589 0 0 3.589 0 8C0 12.411 3.589 16 8 16C12.411 16 16 12.411 16 8C16 3.589 12.411 0 8 0ZM8 14C4.691 14 2 11.309 2 8C2 4.691 4.691 2 8 2C11.309 2 14 4.691 14 8C14 11.309 11.309 14 8 14Z"
							fill="currentColor"
						></path>
						<path
							d="M7.35355 11.0604C7.15829 11.2557 6.84171 11.2557 6.64645 11.0604L3.93955 8.35355C3.74429 8.15829 3.74429 7.84171 3.93955 7.64645L4.64645 6.93955C4.84171 6.74429 5.15829 6.74429 5.35355 6.93955L7 8.586L10.6464 4.93955C10.8417 4.74429 11.1583 4.74429 11.3536 4.93955L12.0604 5.64645C12.2557 5.84171 12.2557 6.15829 12.0604 6.35355L7.35355 11.0604Z"
							fill="currentColor"
						></path>
					</g>
					<g id="sti-check--filled">
						<path
							d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM7.35355 11.0464C7.15829 11.2417 6.84171 11.2417 6.64645 11.0464L3.95355 8.35355C3.75829 8.15829 3.75829 7.84171 3.95355 7.64645L4.64645 6.95355C4.84171 6.75829 5.15829 6.75829 5.35355 6.95355L7 8.6L10.6464 4.95355C10.8417 4.75829 11.1583 4.75829 11.3536 4.95355L12.0464 5.64645C12.2417 5.84171 12.2417 6.15829 12.0464 6.35355L7.35355 11.0464Z"
							fill="currentColor"
						></path>
					</g>
					<g id="sti-close--line">
						<path
							d="M11.9998 3.99995L4 11.9998"
							stroke="currentColor"
							strokeMiterlimit="10"
							strokeLinecap="round"
							strokeLinejoin="round"
						></path>
						<path
							d="M4.00027 4L12.0001 11.9998"
							stroke="currentColor"
							strokeMiterlimit="10"
							strokeLinecap="round"
							strokeLinejoin="round"
						></path>
					</g>
					<g id="sti-close--outline">
						<path
							d="M10.4536 4.85355C10.2583 4.65829 9.94171 4.65829 9.74645 4.85355L8 6.6L6.25355 4.85355C6.05829 4.65829 5.74171 4.65829 5.54645 4.85355L4.85355 5.54645C4.65829 5.74171 4.65829 6.05829 4.85355 6.25355L6.6 8L4.85355 9.74645C4.65829 9.94171 4.65829 10.2583 4.85355 10.4536L5.54645 11.1464C5.74171 11.3417 6.05829 11.3417 6.25355 11.1464L8 9.4L9.74645 11.1464C9.94171 11.3417 10.2583 11.3417 10.4536 11.1464L11.1464 10.4536C11.3417 10.2583 11.3417 9.94171 11.1464 9.74645L9.4 8L11.1464 6.25355C11.3417 6.05829 11.3417 5.74171 11.1464 5.54645L10.4536 4.85355Z"
							fill="currentColor"
						></path>
						<path
							d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM8 14C4.7 14 2 11.3 2 8C2 4.7 4.7 2 8 2C11.3 2 14 4.7 14 8C14 11.3 11.3 14 8 14Z"
							fill="currentColor"
						></path>
					</g>
					<g id="sti-close--filled">
						<path
							d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM11.1464 9.74645C11.3417 9.94171 11.3417 10.2583 11.1464 10.4536L10.4536 11.1464C10.2583 11.3417 9.94171 11.3417 9.74645 11.1464L8 9.4L6.25355 11.1464C6.05829 11.3417 5.74171 11.3417 5.54645 11.1464L4.85355 10.4536C4.65829 10.2583 4.65829 9.94171 4.85355 9.74645L6.6 8L4.85355 6.25355C4.65829 6.05829 4.65829 5.74171 4.85355 5.54645L5.54645 4.85355C5.74171 4.65829 6.05829 4.65829 6.25355 4.85355L8 6.6L9.74645 4.85355C9.94171 4.65829 10.2583 4.65829 10.4536 4.85355L11.1464 5.54645C11.3417 5.74171 11.3417 6.05829 11.1464 6.25355L9.4 8L11.1464 9.74645Z"
							fill="currentColor"
						></path>
					</g>
					<g id="sti-clock">
						<path
							d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM8 14C4.7 14 2 11.3 2 8C2 4.7 4.7 2 8 2C11.3 2 14 4.7 14 8C14 11.3 11.3 14 8 14Z"
							fill="currentColor"
						></path>
						<path
							d="M9 4.5C9 4.22386 8.77614 4 8.5 4H7.5C7.22386 4 7 4.22386 7 4.5V8C7 8.55228 7.44772 9 8 9H11.5C11.7761 9 12 8.77614 12 8.5V7.5C12 7.22386 11.7761 7 11.5 7H9V4.5Z"
							fill="currentColor"
						></path>
					</g>
					<g id="sti-equals">
						<rect y="16" width="44" height="6" rx="1" fill="currentColor"></rect>
						<rect width="44" height="6" rx="1" fill="currentColor"></rect>
					</g>
					<g id="sti-discount">
						<path
							d="M7.99991 1.57331L8.7199 2.40886L9.1199 2.87108C9.17697 2.93924 9.25391 2.98788 9.33996 3.01019C9.42602 3.0325 9.5169 3.02737 9.5999 2.99552L10.1777 2.79997L11.2088 2.43553L11.4132 3.55552L11.5288 4.15107C11.5463 4.23881 11.5895 4.31939 11.6527 4.38266C11.716 4.44593 11.7966 4.48906 11.8843 4.50662L12.4799 4.62217L13.5643 4.82662L13.1999 5.85772L13.0043 6.43549C12.9725 6.51849 12.9673 6.60937 12.9896 6.69542C13.012 6.78148 13.0606 6.85842 13.1288 6.91549L13.591 7.31549L14.4265 8.03548L13.591 8.75547L13.1288 9.15547C13.0606 9.21254 13.012 9.28948 12.9896 9.37553C12.9673 9.46159 12.9725 9.55247 13.0043 9.63547L13.1999 10.2132L13.5643 11.2443L12.4443 11.4132L11.8488 11.5288C11.761 11.5463 11.6804 11.5895 11.6172 11.6527C11.5539 11.716 11.5108 11.7966 11.4932 11.8843L11.3777 12.4799L11.1732 13.5643L10.1421 13.1999L9.56434 13.0043C9.48134 12.9725 9.39046 12.9673 9.30441 12.9897C9.21835 13.012 9.14142 13.0606 9.08434 13.1288L8.68435 13.591L7.99991 14.4265L7.27991 13.591L6.87992 13.1288C6.82285 13.0606 6.74591 13.012 6.65985 12.9897C6.5738 12.9673 6.48292 12.9725 6.39992 13.0043L5.82215 13.1999L4.79105 13.5643L4.5866 12.4443L4.51549 12.1643L4.44438 11.8843C4.42682 11.7966 4.38369 11.716 4.32042 11.6527C4.25715 11.5895 4.17657 11.5463 4.08883 11.5288L3.5555 11.4132L2.47107 11.2088L2.83551 10.1777L3.03106 9.59991C3.06291 9.51691 3.06804 9.42603 3.04573 9.33998C3.02342 9.25392 2.97478 9.17699 2.90662 9.11992L2.4444 8.71992L1.5733 7.99992L2.40885 7.27993L2.87106 6.87993C2.93923 6.82286 2.98786 6.74592 3.01017 6.65987C3.03248 6.57381 3.02736 6.48294 2.99551 6.39994L2.79995 5.82217L2.43551 4.79106L3.5555 4.58662L4.1155 4.4444C4.20324 4.42684 4.28382 4.38371 4.34709 4.32044C4.41036 4.25717 4.45349 4.17658 4.47105 4.08885L4.5866 3.55552L4.79105 2.47108L5.82215 2.83552L6.39992 3.03108C6.48292 3.06293 6.5738 3.06805 6.65985 3.04574C6.74591 3.02343 6.82285 2.9748 6.87992 2.90663L7.27991 2.44442L7.99991 1.57331ZM6.26659 1.57331L4.73771 1.03998C4.61843 0.994907 4.49084 0.976025 4.36361 0.984619C4.23637 0.993213 4.11248 1.02908 4.00034 1.08979C3.8882 1.1505 3.79043 1.23463 3.71368 1.33646C3.63692 1.43829 3.58298 1.55545 3.5555 1.67998L3.27106 3.27108L1.67996 3.55552C1.5544 3.57915 1.43541 3.62956 1.3311 3.70333C1.22679 3.77711 1.1396 3.8725 1.07549 3.98301C1.01138 4.09352 0.971841 4.21656 0.959575 4.34373C0.947309 4.4709 0.962602 4.59922 1.00441 4.71995L1.53774 6.24883L0.311085 7.32437C0.213504 7.40782 0.13516 7.51142 0.081442 7.62804C0.0277243 7.74466 -9.15527e-05 7.87153 -9.15527e-05 7.99992C-9.15527e-05 8.12832 0.0277243 8.25519 0.081442 8.37181C0.13516 8.48843 0.213504 8.59203 0.311085 8.67547L1.53774 9.77769L1.00441 11.3066C0.967083 11.4257 0.955261 11.5513 0.969716 11.6753C0.984171 11.7993 1.02458 11.9189 1.08831 12.0262C1.15204 12.1335 1.23766 12.2262 1.3396 12.2983C1.44154 12.3703 1.55751 12.4201 1.67996 12.4443L3.27106 12.7466L3.5555 14.3199C3.57913 14.4454 3.62955 14.5644 3.70332 14.6687C3.77709 14.773 3.87248 14.8602 3.98299 14.9243C4.09351 14.9885 4.21654 15.028 4.34371 15.0403C4.47089 15.0525 4.59921 15.0372 4.71994 14.9954L6.24881 14.4621L7.30658 15.6887C7.39003 15.7863 7.49363 15.8647 7.61024 15.9184C7.72686 15.9721 7.85373 15.9999 7.98213 15.9999C8.11053 15.9999 8.2374 15.9721 8.35402 15.9184C8.47064 15.8647 8.57423 15.7863 8.65768 15.6887L9.77767 14.4621L11.3065 14.9954C11.4257 15.0328 11.5513 15.0446 11.6753 15.0301C11.7993 15.0157 11.9188 14.9753 12.0262 14.9115C12.1335 14.8478 12.2262 14.7622 12.2983 14.6602C12.3703 14.5583 12.4201 14.4423 12.4443 14.3199L12.7465 12.7288L14.3199 12.4443C14.4454 12.4207 14.5644 12.3703 14.6687 12.2965C14.773 12.2227 14.8602 12.1273 14.9243 12.0168C14.9884 11.9063 15.028 11.7833 15.0402 11.6561C15.0525 11.5289 15.0372 11.4006 14.9954 11.2799L14.4621 9.77769L15.6887 8.71992C15.7863 8.63647 15.8647 8.53287 15.9184 8.41625C15.9721 8.29964 15.9999 8.17276 15.9999 8.04437C15.9999 7.91597 15.9721 7.7891 15.9184 7.67248C15.8647 7.55586 15.7863 7.45227 15.6887 7.36882L14.4621 6.26661L14.9954 4.73773C15.0403 4.61598 15.058 4.48587 15.0473 4.35655C15.0365 4.22723 14.9976 4.10183 14.9332 3.98916C14.8688 3.87649 14.7805 3.77928 14.6746 3.70437C14.5686 3.62945 14.4475 3.57865 14.3199 3.55552L12.7288 3.2533L12.4443 1.67998C12.4207 1.55442 12.3703 1.43543 12.2965 1.33112C12.2227 1.2268 12.1273 1.13962 12.0168 1.07551C11.9063 1.01139 11.7833 0.971856 11.6561 0.95959C11.5289 0.947324 11.4006 0.962618 11.2799 1.00443L9.77767 1.53776L8.67546 0.311101C8.59201 0.21352 8.48841 0.135175 8.3718 0.0814573C8.25518 0.0277395 8.12831 -7.62939e-05 7.99991 -7.62939e-05C7.87151 -7.62939e-05 7.74464 0.0277395 7.62802 0.0814573C7.5114 0.135175 7.40781 0.21352 7.32436 0.311101L6.26659 1.57331ZM9.57323 4.88884H10.3377C10.37 4.88836 10.4018 4.89669 10.4298 4.91295C10.4577 4.92921 10.4807 4.95278 10.4962 4.98112C10.5117 5.00945 10.5193 5.04149 10.5179 5.07378C10.5166 5.10608 10.5066 5.1374 10.4888 5.16439L6.79992 10.9066C6.75976 10.9692 6.70454 11.0207 6.63932 11.0564C6.5741 11.0921 6.50095 11.1109 6.42659 11.111H5.66215C5.62984 11.1115 5.598 11.1032 5.57007 11.0869C5.54214 11.0706 5.51916 11.0471 5.50362 11.0187C5.48808 10.9904 5.48056 10.9584 5.48187 10.9261C5.48318 10.8938 5.49326 10.8624 5.51104 10.8355L9.1999 5.09328C9.24006 5.03069 9.29527 4.97918 9.3605 4.94346C9.42572 4.90774 9.49887 4.88896 9.57323 4.88884ZM9.99989 8.88881C9.78014 8.88881 9.56532 8.95397 9.3826 9.07606C9.19988 9.19815 9.05747 9.37168 8.97337 9.57471C8.88927 9.77773 8.86727 10.0011 8.91014 10.2167C8.95301 10.4322 9.05883 10.6302 9.21422 10.7856C9.36962 10.941 9.56759 11.0468 9.78313 11.0897C9.99866 11.1325 10.2221 11.1105 10.4251 11.0264C10.6281 10.9423 10.8017 10.7999 10.9237 10.6172C11.0458 10.4345 11.111 10.2197 11.111 9.99991C11.111 9.70522 10.9939 9.42261 10.7856 9.21424C10.5772 9.00587 10.2946 8.88881 9.99989 8.88881ZM5.99993 4.88884C5.78017 4.88884 5.56535 4.954 5.38263 5.07609C5.19991 5.19818 5.0575 5.37171 4.9734 5.57474C4.88931 5.77777 4.8673 6.00117 4.91017 6.21671C4.95305 6.43224 5.05887 6.63022 5.21426 6.78561C5.36965 6.941 5.56763 7.04682 5.78316 7.08969C5.99869 7.13257 6.2221 7.11056 6.42513 7.02646C6.62815 6.94237 6.80168 6.79996 6.92377 6.61724C7.04586 6.43452 7.11103 6.2197 7.11103 5.99994C7.11103 5.70526 6.99397 5.42265 6.78559 5.21427C6.57722 5.0059 6.29461 4.88884 5.99993 4.88884Z"
							fill="currentColor"
						></path>
					</g>
					<g id="icon-menu-btn">
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M2 18C2 17.4477 2.44772 17 3 17H21C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19H3C2.44772 19 2 18.5523 2 18Z"
							fill="currentColor"
						></path>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M2 12C2 11.4477 2.44772 11 3 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H3C2.44772 13 2 12.5523 2 12Z"
							fill="currentColor"
						></path>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M2 6C2 5.44772 2.44772 5 3 5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H3C2.44772 7 2 6.55228 2 6Z"
							fill="currentColor"
						></path>
					</g>
				</defs>
			</svg>
		</div>
	);
};

export default IconPackImport;
